export type ChatErrorCode = 'origin_not_allowed' | 'agent_inactive' | 'agent_archived' | 'agent_not_found'
  | 'session_not_found' | 'session_closed' | 'invalid_customer_id' | 'invalid_token' | 'session_unavailable'
  | 'stream_unavailable' | 'token_failed' | 'rate_limited' | 'network' | 'interaction_not_pending'
  | 'interaction_suspended' | 'invalid_interaction' | 'public_chat_disabled' | 'daily_limit_reached' | 'session_limit_reached' | 'unknown';

export interface ChatError {
  code: ChatErrorCode;
  message: string;
  retryable: boolean;
  retryAfterSeconds?: number;
  retryAt?: number;   // epoch ms when a rate-limit wait ends
  origin?: string;
}

const CODES = new Set<ChatErrorCode>(['origin_not_allowed', 'agent_inactive', 'agent_archived', 'agent_not_found',
  'session_not_found', 'session_closed', 'invalid_customer_id', 'invalid_token', 'session_unavailable',
  'stream_unavailable', 'token_failed', 'rate_limited', 'network', 'interaction_not_pending',
  'interaction_suspended', 'invalid_interaction', 'public_chat_disabled', 'daily_limit_reached', 'session_limit_reached', 'unknown']);
const RETRYABLE = new Set<ChatErrorCode>(['rate_limited', 'network', 'session_unavailable', 'stream_unavailable', 'token_failed']);

export function toChatError(code: string | undefined, message?: string): ChatError {
  const known = (code && CODES.has(code as ChatErrorCode) ? code : 'unknown') as ChatErrorCode;
  return { code: known, message: message || known, retryable: RETRYABLE.has(known) };
}

export class ChatRequestError extends Error {
  constructor(public readonly error: ChatError, public readonly status: number) {
    super(error.message);
    this.name = 'ChatRequestError';
  }
}
